import $ from 'jquery'

$('#contact-form').on('submit', function (event) {
  event.preventDefault()

  var formData = $(this).serialize()

  $.ajax({
    url: 'https://submit-form.com/IbSFaZR9q',
    method: 'POST',
    data: formData,
    dataType: 'json',
    success: function (response) {
      //
      $('.create-form-success').show()
      $('.create-form-error').hide()
      $('#contact-form')[0].reset()
    },
    error: function (error) {
      $('.create-form-success').hide()
      $('.create-form-error').show() // Show error message
    },
  })
})
